import React from "react";
import logger from "main/shared/logger";

class ErrorBoundary extends React.Component {
  state = {
    errorMessage: "",
  };

  static getDerivedStateFromError(error) {
    return { errorMessage: error.toString() };
  }

  componentDidCatch(error, info) {
    this.logErrorToServices(error.toString(), info.componentStack);
  }

  // A fake logging service.
  logErrorToServices = logger.log;

  render() {
    if (this.state.errorMessage) {
      return <p>Error: {this.state.errorMessage}</p>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
